import React from 'react';
// import Button from 'react-bootstrap/Button';
import IconButton from '../common/IconButton';
import CsvIcon from '../../media/CsvIcon.png';

const CustomCSVButton = (props) => {

    const handleClick = e => {
        e.preventDefault();
        props.onExport();
    }

    return(
        <IconButton 
            buttonClassName="btn-outline-secondary" 
            icon={<img alt="Export CSV" src={CsvIcon} style={{ height : "24px" }} />}
            onClick={handleClick}
        >
            Export CSV
        </IconButton>
    );
}

export default CustomCSVButton;